module.exports = __webpack_public_path__ + "img/aboutus.29e69d2d.png";